enum VehicleType {
  Bus,
  Car,
  ConcreteMixer,
  FlatDeckTrailer,
  Forklift,
  LongerTrailer,
  Pickup,
  PrimeMover,
  RefrigeratedRailCar,
  RefrigeratedTrailer,
  RefrigeratedTruck,
  RubbishTruck,
  ShorterTrailer,
  TankerTrailer,
  TipTruck,
  Trailer,
  Van,
}

export default VehicleType;
